import { render } from "./IzinSiswa.vue?vue&type=template&id=39e4c751"
import script from "./IzinSiswa.vue?vue&type=script&lang=js"
export * from "./IzinSiswa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__